import { Address } from 'api/client-domain/client-domain.types';
import * as yup from 'yup';

export const addressFormSchema: yup.SchemaOf<{ address: Address }> = yup
  .object()
  .shape({
    address: yup.object().shape({
      streetAddress1: yup.string().required().max(100).default(''),
      streetAddress2: yup.string().max(100).nullable().default(''),
      city: yup.string().required().max(100).default(''),
      region: yup.string().required().default(''),
      postalCode: yup.string().required().max(50).default(''),
      country: yup.string().required().default(''),
    }),
  });

export const latLonFormSchema = yup.object({
  latitude: yup.lazy(value =>
    value == null || value === ''
      ? yup.string().required().flexDefault('')
      : yup.number().min(-89.99999999).max(90),
  ),
  longitude: yup.lazy(value =>
    value == null || value === ''
      ? yup.string().required().flexDefault('')
      : yup.number().min(-179.99999999).max(180),
  ),
});

export const optionalLatLonFormSchema = yup.object({
  latitude: yup.lazy(value =>
    value == null || value === ''
      ? yup.string().flexDefault('')
      : yup.number().min(-89.99999999).max(90),
  ),
  longitude: yup.lazy(value =>
    value == null || value === ''
      ? yup.string().flexDefault('')
      : yup.number().min(-179.99999999).max(180),
  ),
});
